module.exports = __webpack_public_path__ + "img/department.d7feb09a.png";